/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ImageComponentDisplay } from "cms/components/components/image/display";
import { ImageComponentEditor } from "cms/components/components/image/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

function ImageComponent (props) {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <ImageComponentDisplay />,
        editComponent: <ImageComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
}

ImageComponent.displayName = "ImageComponent";
export { ImageComponent };
